import {
  EventType,
  LogLevel,
  PublicClientApplication,
} from "@azure/msal-browser";

const pca = new PublicClientApplication({
  auth: {
    clientId: import.meta.env.VITE_CLIENTID,
    authority: import.meta.env.VITE_AUTHORITY,
    redirectUri: import.meta.env.VITE_REDIRECTURI, // e.g. http://localhost:5173/signin
    postLogoutRedirectUri: import.meta.env.VITE_LOGOUTREDIRECT,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "sessionStorage", // "sessionStorage" is more secure, but "localStorage" enables SSO across tabs
    storeAuthStateInCookie: false, // Set to "true" if you have issues on IE11/Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
        }
      },
    },
  },
});

// Ensure active account is restored after reload
pca.initialize().then(() => {
  const accounts = pca.getAllAccounts();
  if (!pca.getActiveAccount() && accounts.length > 0) {
    pca.setActiveAccount(accounts[0]);
  }
});

// Keep account active after login or token acquisition
pca.addEventCallback((event) => {

  if (
    event.eventType === EventType.LOGIN_SUCCESS ||
    event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS
  ) {
    if (event.payload && event.payload.account) {
      pca.setActiveAccount(event.payload.account);
    }
  }
});

export default pca;